import React from 'react'
import { ForgotPasswordContainer } from '@/components/containers/forgot-password'

export const ForgotPasswordPage: React.FC = () => {
  return <ForgotPasswordContainer />
}
